import React from 'react'
import { Link } from 'react-router-dom'

export default function ViewButton({children}) {
  return (
    <Link to={children} title="" className="btn btn-primary"><i className="fas fa-eye"></i></Link>
  )
}
